export const roles = {
    HAULER_ADMIN: 'Admin',
    DRIVER: 'Driver',
};

export const RESTRICTED_ACCESS_ROLES = {
    BILLING: 'Billing',
    DISPATCH: 'Dispatch',
};

export const roleEnums = {
    APP_ADMIN: 'APP_ADMIN',
    HAULER_ADMIN: 'HAULER_ADMIN',
    DRIVER: 'DRIVER',
    BILLING: 'BILLING',
    DISPATCH: 'DISPATCH',
};
